module.exports = __webpack_public_path__ + "img/about_img_01.6505bc4c.jpg";